import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { QrCodeResponse } from '../../responses/qr-code-response';
import { EmailPasswordComponent } from './components/email-password/email-password.component';
import { VerificationCodeComponent } from './components/verification-code/verification-code.component';

@Component({
  selector: 'app-login',
  imports: [EmailPasswordComponent, VerificationCodeComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  emailPasswordAuthenticated!: boolean;
  verificationCodeauthenticated!: boolean;
  qrCodeResponse?: QrCodeResponse;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.emailPasswordAuthenticated = false;
  }

  handleEmailPasswordLogin(login: QrCodeResponse) {
    this.qrCodeResponse = login;
    this.emailPasswordAuthenticated = true;
  }

  handleVerificationCodeLogin(login: boolean) {
    this.verificationCodeauthenticated = login;
  }
}
